import React, { useCallback } from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import FieldContainer from '../../field-container/FieldContainer';
import Input from '../../form/Input';

const Slump = ({ className, disabled, value }) => {
  return (
    <FieldContainer className={cn('slump', className)}>
      <div className="label-spinner">
        <div className="label">Slump</div>
        <div className={cn('spinner', { spinning: false })}>
          <span className="fas fa-sync fa-spin" />
        </div>
      </div>
      <Input type="text" value={value || ''} disabled data-testid="slump_input" readOnly />
    </FieldContainer>
  );
};

export default styled(Slump)``;
